<template>
  <div id="SqueezePage">
    <router-link :to="{name: 'Land'}"><img src="@/assets/logo2.png" class="brand-logo"/></router-link>
  <div class="main">
    <SqueezeConfirmedOrder />
    <!-- <SqueezeContent /> -->
  </div>
  <Footer />
</div>
</template>

<script>
import SqueezeConfirmedOrder from '@/components/squeeze/SqueezeConfirmedOrder.vue'
// import SqueezeContent from '@/components/squeeze/SqueezeContent.vue'
import Footer from '@/components/layout/sections/Footer.vue'
export default {
  name: 'SqueezePage',
  components: {
    SqueezeConfirmedOrder,
    // SqueezeContent,
    Footer
  },
  data(){
    return{
    }
  },
  methods:{
    displayMinPerCost(count, cost){
      return ((cost/count)*100).toFixed(1)
    }
  }
}
</script>
<style scoped>
#SqueezePage{
  position: relative;
  margin: 0 auto;
  /* max-width: 900px; */
}
.brand-logo{  width: 20rem;}
.presentation{
  width: 100%;
  background-color: #444;
  display: flex;
  justify-content: center;
  align-items:center;
}
.skip-source-phone{
  background-color: #fff;
  width: 30%;
  margin: 2rem auto;
  padding: 2rem 5rem;
}
.skip-source-phone img{
  width:100%;
}
.main{
  width:100%;
  min-height: 80vh;
  display: flex;
  justify-content: center;
  align-items: stretch;
  align-content: stretch;
}
@media screen and (max-width: 900px) {
  .main{
    width:100%;
    flex-direction: column;
  }
}
</style>
